// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Potongan_table_wrapper__ixUhe"};